export class ChatbotSession {
  id = ''
  msisdn = ''
  brand = ''
  channel = ''
  entryPoint = ''
  lastMessageDate = ''
  context = {}
}
